module.exports = __webpack_public_path__ + "images/8a6803604781cf80191052e436fbb7e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./webpack/assets/img/wheels-locations07.jpg
// module id = ./webpack/assets/img/wheels-locations07.jpg
// module chunks = 0